module.exports = __webpack_public_path__ + "img/no-video.8b6b1d4f.png";